export default __webpack_public_path__ + "e769aa77798cffeb58423d7cda9bfe88.woff2";